const TimeRangeSelectorSkeleton = () => {
  return (
    <div className="flex space-x-2 md:mr-8">
      <button
        className={`py-2 px-4 text-sm font-medium rounded animate-pulse bg-gray-200`}
      >
        <span className="opacity-0">24h</span>
      </button>
      <button
        className={`py-2 px-4 text-sm font-medium rounded animate-pulse bg-gray-200`}
      >
        <span className="opacity-0">7d</span>
      </button>
      <button
        className={`py-2 px-4 text-sm font-medium rounded animate-pulse bg-gray-200`}
      >
        <span className="opacity-0">30d</span>
      </button>
      <button
        className={`py-2 px-4 text-sm font-medium rounded animate-pulse bg-gray-200`}
      >
        <span className="opacity-0">All</span>
      </button>
    </div>
  );
};

export default TimeRangeSelectorSkeleton;
